export default __webpack_public_path__ + "static/media/Goku.b3b6c689.png";